import { Fragment, useEffect, useRef, useState } from "react";

import styles from "@/styles/containers/products.module.scss";

import { Button } from "@/components";
import { NoPicture, Search } from "@/components/Icons";
import { CatalogHelpers, OlgaImageLoader } from "@/tools";
import classNames from "classnames/bind";
import { useLocale, useTranslations } from "next-intl";
import { CartShortcut } from "../CartShortcut";
import Image from "next/image";
import debounce from "lodash.debounce";
import InputSearch from "@/components/InputSearch";
const css = classNames.bind(styles);

const Product = ({ item, onSelectProduct, searchTerm }) => {
  const t = useTranslations();

  // const imageUrlRef = useRef(
  // 	`${process.env.NEXT_PUBLIC_CDN_ASSETS}/${item.image}`,
  // );
  // const canvasRef = useRef();

  // useEffect(() => {
  // 	function renderCanvasImage(imgSrc) {
  // 		const canvas = canvasRef.current;
  // 		const context = canvas.getContext("2d");
  // 		const imageObj = new Image();
  // 		imageObj.src = imgSrc;

  // 		imageObj.onload = function () {
  // 			canvas.width = imageObj.naturalWidth;
  // 			canvas.height = imageObj.naturalHeight;

  // 			if (imageObj.naturalWidth >= 1500 || imageObj.naturalHeight >= 1500) {
  // 				canvas.width = imageObj.naturalWidth / 5;
  // 				canvas.height = imageObj.naturalHeight / 5;
  // 			}

  // 			context.drawImage(imageObj, 0, 0, canvas.width, canvas.height);
  // 		};
  // 	}

  // 	item?.image && renderCanvasImage(imageUrlRef.current);
  // }, [item.image, item.name, item.id]);

  const oldPrice = CatalogHelpers.mountOldPrice(item);
  const hasAddons = (item.items || []).length > 0;
  const hasSizes = (item.sizes || []).length > 1;

  const locale = useLocale();

  if (searchTerm && !item.name?.toLowerCase().includes(searchTerm)) return;

  return (
    <div className={styles.product} onClick={() => onSelectProduct(item, item)}>
      {item?.image ? (
        <div className={styles.picture}>
          <Image
            src={`${process.env.NEXT_PUBLIC_CDN_ASSETS}/${item.image}`}
            alt={item.name}
            placeholder="blur"
            blurDataURL={OlgaImageLoader.BLURRED_IMG}
            loader={OlgaImageLoader.load}
            fill
          />
        </div>
      ) : (
        <div className={styles.noPicture}>
          <NoPicture />
        </div>
      )}
      <div className={styles.details}>
        <p className={styles.name}>
          {CatalogHelpers.getTranslation({
            item,
            field: "name",
            locale,
          })}
        </p>
        {item.description && (
          <p className={styles.description}>
            {CatalogHelpers.getTranslation({
              item,
              field: "description",
              locale,
            })}
          </p>
        )}
        <div className="d-flex align-end justify-between flex-1 mt-20">
          {CatalogHelpers.isPromotionalPrice(item) &&
          oldPrice &&
          !(hasAddons || hasSizes) ? (
            <p className={styles.fromPrice}>
              <strike>{oldPrice}</strike>&nbsp;&nbsp;
              <span className={styles.price}>
                {CatalogHelpers.mountPrice(item)}
              </span>
            </p>
          ) : CatalogHelpers.isPromotionalPrice(item) && !hasSizes ? (
            <p className={styles.fromPrice}>
              {t("startingFrom")}&nbsp;
              <span className={styles.price}>
                {CatalogHelpers.mountPrice(item)}
              </span>
              &nbsp;&nbsp;
              <strike>{oldPrice}</strike>
            </p>
          ) : hasAddons || hasSizes ? (
            <p className={styles.fromPrice}>
              {t("startingFrom")}&nbsp;
              <span className={styles.price}>
                {CatalogHelpers.mountPrice(item)}
              </span>
            </p>
          ) : (
            <p className={styles.fromPrice}>
              <span className={styles.price}>
                {CatalogHelpers.mountPrice(item)}
              </span>
            </p>
          )}
          <Button design="secondary-two" onClick={() => onSelectProduct(item)}>
            {t("add")}
          </Button>
        </div>
      </div>
    </div>
  );
};

const CategoryItem = ({
  category,
  onSelectProduct,
  categorySelected,
  searchTerm,
}) => {
  if (categorySelected?.id !== category.id) return null;

  const locale = useLocale();

  return (
    <div
      className={css({
        productsContainer: true,
        visible: true,
      })}
    >
      <p className={styles.categoryName}>
        {CatalogHelpers.getTranslation({
          item: categorySelected,
          field: "name",
          locale,
        })}
      </p>
      <div className={styles.products}>
        {category.items.map((item) => {
          return (
            item.show &&
            item.showAll !== false &&
            item.showTablet !== false &&
            item.available &&
            item.visible && (
              <Fragment key={item.id}>
                <Product
                  item={item}
                  onSelectProduct={onSelectProduct}
                  searchTerm={searchTerm}
                />
              </Fragment>
            )
          );
        })}
      </div>
    </div>
  );
};

export default function Products({
  categories,
  category,
  onSelectProduct,
  onOpenCart,
  onSearch,
}) {
  const inputRef = useRef(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [openSearch, setOpenSearch] = useState(false);

  const onSearchItemOnCatalog = (e) => {
    const term = (e.target.value || "")?.toLowerCase();
    setSearchTerm(term);
    onSearch(term);
  };

  const clearInput = () => {
    if (inputRef.current) inputRef.current.value = "";
  };

  const t = useTranslations();

  return (
    <div className={styles.catalogContainer}>
      <div className={styles.header}>
        {/* <p className={styles.categoryName}>{category?.name}</p> */}

        <div className="d-flex align-center justify-end w-100">
          {!openSearch && (
            <div
              className="d-flex align-center pointer"
              onClick={() => setOpenSearch(true)}
            >
              <Search />
            </div>
          )}
          {openSearch && (
            <>
              <InputSearch
                ref={inputRef}
                placeholder={t("whatAreYouLookingFor")}
                className="w-100"
                onChange={debounce(onSearchItemOnCatalog, 1000)}
                autoFocus
                erase={() => {
                  clearInput();
                  setSearchTerm("");
                  onSearch("");
                }}
              />

              <Button
                onClick={() => {
                  clearInput();
                  setSearchTerm("");
                  onSearch("");
                  setOpenSearch(false);
                }}
                design="underline"
                className="ml-20"
              >
                {t("cancel")}
              </Button>
            </>
          )}
          <CartShortcut onOpenCart={onOpenCart} />
        </div>
      </div>

      {Object.keys(categories).map((groupId) => {
        return categories[groupId]
          .filter((item) => item.items.length > 0)
          .map((item) => {
            return (
              item.show &&
              item.available &&
              item.visible && (
                <CategoryItem
                  key={item.id}
                  category={item}
                  categorySelected={category}
                  searchTerm={searchTerm}
                  onSelectProduct={(product) => onSelectProduct?.(product)}
                  onOpenCart={onOpenCart}
                />
              )
            );
          });
      })}
    </div>
  );
}
